@if (styledChartOption && chartTheme) {
  <div echarts [options]="styledChartOption" class="h-full w-full"></div>
} @else {
  <div class="flex h-full w-full animate-fade-in flex-col items-center justify-center duration-200">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
      class="mb-1 text-gray-400 dark:text-gray-100" aria-hidden="true">
      <path d="M3 3v18h18" />
      <path d="M18 17V9" />
      <path d="M13 17V5" />
      <path d="M8 17v-3" />
    </svg>
    <h4 class="text-md font-semibold text-gray-400 dark:text-gray-100">No data</h4>
  </div>
}
